import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, AlteraSenhaDetranRequest } from './types';

// ACTIONS
import { alteraSenhaDetranSuccess, alteraSenhaDetranFailure } from './actions';

function* alteraSenhaDetranRequest(request: ReducerAction) {
	const { payload }: { payload: AlteraSenhaDetranRequest } = request;

	const response: ApiResponse = yield call(
		putApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/senha`,
		payload,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(alteraSenhaDetranSuccess(response.data));
	} else {
		yield put(alteraSenhaDetranFailure(response));
	}
}

export default all([
	takeLatest(Types.ALTERA_SENHA_DETRAN_REQUEST, alteraSenhaDetranRequest),
]);
